export default "__VITE_ASSET__0ba74218__"